import { ACCEPTABLE_USE_POLICY } from "../../assets/legal/AcceptableUsePolicy"
import { PRIVACY_POLICY } from "../../assets/legal/PrivacyPolicy"
import { TERMS_OF_SERVICE } from "../../assets/legal/TermsOfService"
import { postPolicyAcceptance } from "../../clients/bettercallkyle/BckApi"
import { refreshUserData } from "../profile/UserActions"
import { getSiteByIdForUser } from "./SiteActions"

const USER_POLICIES = {
    ['PRIVACY_POLICY']: PRIVACY_POLICY,
    ['ACCEPTABLE_USE_POLICY']: ACCEPTABLE_USE_POLICY
}

const SITE_POLICIES = {
    ['TERMS_OF_SERVICE']: TERMS_OF_SERVICE
}

export const getPolicyFromPolicyType = (policy_type) => {
    const policy = USER_POLICIES[policy_type];
    if (!policy) return SITE_POLICIES[policy_type];
    return policy;
}
  
export const validatePolicyAcceptance = (user, sites) => {
    if (!user || !sites) throw new Error("No site or user provided");

    const lapsedPolicies = [];

    const { user_policy_acceptance } = user;
    Object.keys(USER_POLICIES).forEach(policy_type => {
        const policy = USER_POLICIES[policy_type];
        if (!user_policy_acceptance
            || !user_policy_acceptance[policy.type]
            || user_policy_acceptance[policy.type].version < policy.version) {
            lapsedPolicies.push({ policy_type: policy.type });
        }
    });

    // COMMENTED OUT UNTIL LEGAL IS COMPLETE
    /*sites.forEach(site => {
        const { site_policy_acceptance, site_security, site_id, site_details } = site;
        
        if (!site_security.is_primary_user) return;
        Object.keys(SITE_POLICIES).forEach(policy_type => {
            const policy = SITE_POLICIES[policy_type];
            if (!site_policy_acceptance
                || !site_policy_acceptance[policy.type]
                || site_policy_acceptance[policy.type].version < policy.version) {
                    lapsedPolicies.push({ policy_type: policy.type, site_id });
            }
        })
    });*/
    
    return lapsedPolicies;
}

export const updatePolicyAcceptance = async (siteId, userId, policy) => {
    if (!userId) throw new Error("No user id");
    try {
        const resp = await postPolicyAcceptance(siteId, userId, policy);
        await refreshUserData(userId);
        if (siteId) await getSiteByIdForUser(siteId, userId, true);
        return resp;
    } catch(err) {
        console.error(err);
        throw new Error("Could not accept policy at this time. Please try again in a few moments.");
    }
}

  